import { ManualDetail } from './manualWinner';

export function isSwitchExperiment(detail: ManualDetail): boolean {
  return detail.smartTestEnabled === true && detail.sceneType === 1;
}

export function switchRequiresReopen(detail: ManualDetail): boolean {
  return isSwitchExperiment(detail) && detail.status === 0 && detail.mainFormStatus === 0;
}
